import { ICON__images_solid } from '@/assets/icons_fa';
import { ICON__grid_3x3 } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';

interface PROPS {}

export function GRID2D_BUTTON__show_as_gallery({}: PROPS) {
  const dispatch = use_dispatch();
  /*
   *
   */
  const { global__grid2d_show_as_gallery } = use_slice_ui(['global__grid2d_show_as_gallery']);

  /*
   *
   */

  use_effect(() => {
    return () => void dispatch(LOCAL__ui_set_boolean({ key: 'global__grid2d_show_as_gallery', value: false }));
  }, []);

  /*
   *
   */
  function onClick(event: React.MouseEvent<HTMLElement>): void {
    event.stopPropagation();

    dispatch(LOCAL__ui_set_boolean({ key: 'global__grid2d_show_as_gallery', value: !global__grid2d_show_as_gallery }));
  }

  /*
   *
   */

  return (
    <>
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-bar'}
        Icon={global__grid2d_show_as_gallery ? ICON__grid_3x3 : ICON__images_solid}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        {...{ onClick }}
        className="p-0 h-[28px] w-[30px] flex items-center justify-center"
        iconClassNameBase="!text-component-item-foreground !size-3"
        iconClassNameHovered="!text-bar-foreground"
      />
    </>
  );
}
